import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "@mui/material";
import { getAffList } from "../../store/reducers/affiliateReducer";
import searchicon from "../../assets/icons/searchIcon.svg";
import PaginationComponent from "../../utilities/Pagination";
import TickIcon from "../../assets/icons/tick-close.svg";
import crossIcon from "../../assets/icons/circle-close.svg";
import { useLocation } from "react-router";
import Loader from "../../reusableComponents/Loader";
import CopyToClipboard from "react-copy-to-clipboard";
import { handleCopyToClipboard } from "../../utilities/string";
import { ReactComponent as SmallCopyIcon } from "../../assets/icons/NewIcons/smallCopyIcon.svg";

// const CopyToClipBoard = ({ cell }) => {
//   const [copied, setCopied] = useState(false);

//   const onCopyText = () => {
//     setCopied(true);
//     setTimeout(() => {
//       setCopied(false);
//     }, 2000);
//   };

//   const updateClipboard = (newClip) => {
//     navigator.clipboard.writeText(newClip).then(
//       () => {
//         onCopyText();
//       },
//       () => {
//         console.log("Copy unsuccessful");
//       }
//     );
//   };

//   return (
//     <span style={{ marginLeft: "10px" }} onClick={() => updateClipboard(cell)}>
//       <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
//         <path d="M8.64372 0.250489C9.21685 0.250489 9.7665 0.47816 10.1718 0.88342C10.577 1.28868 10.8047 1.83833 10.8047 2.41145L10.8047 8.71426C10.8047 9.28739 10.577 9.83704 10.1718 10.2423C9.7665 10.6476 9.21685 10.8752 8.64373 10.8752L2.16083 10.8752C1.58771 10.8752 1.03806 10.6476 0.632802 10.2423C0.227543 9.83704 -0.000130027 9.28739 -0.000130127 8.71426L-0.000131229 2.41145C-0.000131329 1.83833 0.227541 1.28868 0.6328 0.883421C1.03806 0.478162 1.58771 0.25049 2.16083 0.25049L8.64372 0.250489ZM9.72421 2.41145C9.72421 2.12489 9.61037 1.85007 9.40774 1.64744C9.20511 1.44481 8.93029 1.33097 8.64372 1.33097L2.16083 1.33097C1.87427 1.33097 1.59945 1.44481 1.39682 1.64744C1.19419 1.85007 1.08035 2.12489 1.08035 2.41145L1.08035 8.71426C1.08035 9.00083 1.19419 9.27565 1.39682 9.47828C1.59945 9.68091 1.87427 9.79475 2.16083 9.79475L8.64373 9.79474C8.93029 9.79474 9.20511 9.68091 9.40774 9.47828C9.61037 9.27565 9.72421 9.00082 9.72421 8.71426L9.72421 2.41145Z" fill="#F6F6F6" />
//         <path d="M12.9629 1.87139C12.9629 1.49208 12.863 1.11944 12.6734 0.790944C12.4837 0.462446 12.2109 0.18966 11.8824 1.88917e-07L11.8824 9.25469C11.8824 9.97109 11.5978 10.6582 11.0912 11.1647C10.5847 11.6713 9.89761 11.9559 9.18121 11.9559L2.44764 11.9559C2.6373 12.2844 2.91009 12.5572 3.23859 12.7468C3.56708 12.9365 3.93972 13.0364 4.31904 13.0364L9.18121 13.0364C10.1842 13.0364 11.1461 12.6379 11.8553 11.9287C12.5645 11.2195 12.9629 10.2577 12.9629 9.25469L12.9629 1.87139Z" fill="#F6F6F6" />
//       </svg>
//     </span>
//   );
// };

const List = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { paginated_affiliates } = useSelector((state) => state.affiliate);
  const [search, setSearch] = useState("");
  const selectedAffiliate = useSelector(
    (state) => state.affiliate.selectedAffiliate
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { list } = useSelector((state) => state.affiliate);
  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(loader);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  const itemsPerPage = pageSize;
  const totalItems = list?.count || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const id =
    paginated_affiliates?.result && paginated_affiliates?.results[0]?.id;
  const affiliateId = selectedAffiliate || id;

  useEffect(() => {
    if (affiliateId) {
      dispatch(getAffList(affiliateId, search, currentPage, itemsPerPage));
    }
  }, [dispatch, affiliateId, currentPage, itemsPerPage, search]);

  const columns = [
    {
      dataField: "percentage",
      text: "Commission %",
      formatter: (cell) => (cell != null ? `${cell.toFixed(2)}%` : "-"),
    },
    {
      dataField: "repeat_percent",
      text: "% (Repeat)",
      formatter: (cell) => (cell != null ? `${cell.toFixed(2)}%` : "-"),
    },
    {
      dataField: "code",
      text: "Affiliate Code",
      formatter: (cell) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {cell || "-"}
          <CopyToClipboard
            onCopy={() => handleCopyToClipboard("Affiliate Code Copied!")}
            text={cell}
          >
            <SmallCopyIcon style={{ cursor: "pointer", marginLeft: "10px" }} />
          </CopyToClipboard>
        </div>
      ),
    },
    {
      dataField: "pushed_leads",
      text: "Pushed Leads",
      formatter: (cell) => (cell != null ? cell : "-"),
    },
    {
      dataField: "consumed_by_count",
      text: "Conversions",
      formatter: (cell) => (cell != null ? cell : "-"),
    },
    {
      dataField: "url",
      text: "URL",
      formatter: (cell) =>
        cell ? (
          <a
            href={cell}
            target="_blank"
            rel="noopener noreferrer"
            className="aff_code_url"
          >
            <span>{cell.substring(0, 40)}</span>
          </a>
        ) : (
          "-"
        ),
    },
  ];

  const [filter, setFilter] = useState("All");

  const filteredData = list?.results?.filter((item) => {
    if (filter === "Active") return item.status === "Active";
    if (filter === "Inactive") return item.status === "Inactive";
    return true; // For 'All'
  });

  const handleFilterChange = (status) => {
    setFilter(status);
  };

  const inputRef = useRef(null);

  // Logic for pagination

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <div id="aff-code-list-table">
      <Loader open={open} />
      <div className="table_header">
        <div className="table_header_left">
          <div className="search_bar_wrapper">
            <img src={searchicon} alt="searchicon" />
            <input
              type="text"
              className="search_input"
              placeholder="Search..."
              ref={inputRef}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        {/* <div className="tab_buttons">
          <Button
            className={filter === "All" ? "newTabination-item active" : "newTabination-item"}
            onClick={() => handleFilterChange("All")}
          >
            All
          </Button>
          <Button
            className={filter === "Active" ? "newTabination-item active" : "newTabination-item"}
            onClick={() => handleFilterChange("Active")}
          >
            Active
          </Button>
          <Button
            className={filter === "Inactive" ? "newTabination-item active" : "newTabination-item"}
            onClick={() => handleFilterChange("Inactive")}
          >
            Inactive
          </Button>
        </div> */}
      </div>

      <BootstrapTable
        keyField="id"
        data={filteredData || []}
        columns={columns}
        noDataIndication="No data available"
      />

      <PaginationComponent
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        pageSize={itemsPerPage}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default List;
